/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ stage: NonNullable<unknown>, contextType: NonNullable<unknown> }} Stage_Banner_Warning_BodyInputs */

const en_stage_banner_warning_body = /** @type {(inputs: Stage_Banner_Warning_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There are still incomplete tasks in the active stage (${i?.stage}). We strongly recommend completing these checklist items before moving the ${i?.contextType} forward to prevent process gaps.`)
};

const pt_br2_stage_banner_warning_body = /** @type {(inputs: Stage_Banner_Warning_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ainda há atividades incompletas na etapa ativa (${i?.stage}). Recomendamos fortemente concluir esses itens antes de avançar o ${i?.contextType} para evitar lacunas no processo.`)
};

/**
* | output |
* | --- |
* | "There are still incomplete tasks in the active stage ({stage}). We strongly recommend completing these checklist items before moving the {contextType} forwar..." |
*
* @param {Stage_Banner_Warning_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const stage_banner_warning_body = /** @type {((inputs: Stage_Banner_Warning_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Banner_Warning_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_banner_warning_body(inputs)
	return pt_br2_stage_banner_warning_body(inputs)
});